var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    title: _vm.tooltipText,
    // container: '.' + guid,
    placement: 'top',
    delay: 50,
    wrapperClass: 'dark',
  }),expression:"{\n    title: tooltipText,\n    // container: '.' + guid,\n    placement: 'top',\n    delay: 50,\n    wrapperClass: 'dark',\n  }"}],class:['-transcribe-gap', '-gap', _vm.guid, { '-irrelevant': !_vm.isRelevant }],on:{"click":_vm.onClick}},[_c('i',{staticClass:"wticon wticon-plus"}),_vm._v("+")])}
var staticRenderFns = []

export { render, staticRenderFns }